import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Typography } from '@mui/material'
import { Scheduler } from '../../components/scheduler/Scheduler.jsx'
import { TimeLineHeader } from './TimeLineHeader.jsx'
import { toastHelper } from '../../util/toastHelper.js'
import styles from './timeLineStyle.module.scss'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'
import ListToolbar from '../../components/dataGrid/ListToolBar'
import FilterPopover from '../../components/dataGrid/FilterPopover'

/* TODO:: Make this work as a planner timeline using API response */
export const PlannerTimelinePage = ({ title }) => {
	const dispatch = useDispatch()

	const role = useSelector((state) => state.kazooEvent.role)
	const user = useSelector((state) => state.auth.user)
	const timelineEvents = useSelector(
		(state) => state.scheduler.timelineEvents || []
	)

	const [search, setSearch] = useState('')
	const [statusFilter, setStatusFilter] = useState([])
	const [selectedWeddings, setSelectedWeddings] = useState([])
	const [filterAnchor, setFilterAnchor] = useState(null)
	const weddingsMockData = [
		{ name: "Alice's wedding", status: 'Upcoming', color: '#64B5F6' },
		{ name: "Jhone's wedding", status: 'Active', color: '#9C27B0' },
		{ name: "Albert's wedding", status: 'Completed', color: '#E91E63' },
		{ name: "Mike's wedding", status: 'Active', color: '#F44336' },
		{ name: "Kevin's wedding", status: 'Active', color: '#F44336' },
		{ name: "Alice's wedding", status: 'Upcoming', color: '#4CAF50' },
	]
	const partyMembers = [{ Id: user._id, OwnerText: user.businessName }]

	const filteredEvents = useMemo(() => {
		const q = search.trim().toLowerCase()
		return timelineEvents.filter((event) => {
			if (
				q &&
				!(
					event.subject?.toLowerCase().includes(q) ||
					event.Description?.toLowerCase().includes(q)
				)
			) {
				return false
			}
			if (statusFilter.length && !statusFilter.includes(event.Status)) {
				return false
			}
			return true
		})
	}, [timelineEvents, search, statusFilter])

	const weddingChips = selectedWeddings.map((wedding) => ({
		key: `wedding-${wedding.name}`,
		label: wedding.name,
		color: wedding.color,
		onDelete: () =>
			setSelectedWeddings((prev) =>
				prev.filter((w) => w.name !== wedding.name)
			),
	}))

	const statusChips = statusFilter.map((s) => ({
		key: `status-${s}`,
		label: `Status: ${s}`,
		onDelete: () => setStatusFilter((prev) => prev.filter((x) => x !== s)),
	}))

	const chips = [...weddingChips, ...statusChips]

	const clearFilters = () => {
		setStatusFilter([])
		setSelectedWeddings([])
		setSearch('')
	}

	const openFilter = (e) => setFilterAnchor(e.currentTarget)
	const closeFilter = () => setFilterAnchor(null)

	// useEffect(() => {
	//     dispatch(getVendorEvents()) // to display events
	// }, [dispatch])

	// Function to handle saving events to the server
	const onActionBegin = async (args) => {
		if (
			args.requestType === 'eventCreate' ||
			args.requestType === 'eventChange' ||
			args.requestType === 'eventRemove'
		) {
			if (role === 'vendor') {
				return toastHelper(
					'You only have view permissions as a vendor FOR NOW',
					'error'
				)
			}
		}
	}

	const eventSettings = {
		allowAdding: false,
		allowEditing: false,
		allowDeleting: false,
		allowResizing: false,
		allowDrag: false,
		dataSource: [].map((event) => ({
			...event,
		})),
	}

	return (
		<div className={styles.container}>
			<TimeLineHeader title={title} />
			<br />
			<Box
				className={styles.tableWrap}
				sx={{
					px: '24px',
				}}
			>
				<ListToolbar
					title="Timeline Events"
					searchPlaceholder="Search events"
					searchValue={search}
					onSearchChange={setSearch}
					chips={chips}
					onClearFilters={clearFilters}
					onOpenFilter={openFilter}
					showExport={false}
					isExported={false}
				/>
				<FilterPopover
					anchorEl={filterAnchor}
					open={Boolean(filterAnchor)}
					onClose={closeFilter}
					onClear={clearFilters}
					onApply={closeFilter}
					sections={[
						{
							id: 'status',
							title: 'Status',
							options: ['Completed', 'In Progress', 'Pending'],
							selected: statusFilter,
							onToggle: (val, checked) =>
								setStatusFilter((prev) =>
									checked
										? [...prev, val]
										: prev.filter((x) => x !== val)
								),
						},
					]}
					page="planner-timeline"
					weddingsMockData={weddingsMockData}
					selectedWeddings={selectedWeddings}
					onToggleWedding={(wedding, checked) => {
						if (wedding === 'select-all') {
							setSelectedWeddings(checked ? [...weddingsMockData] : []);
						} else if (checked) {
							setSelectedWeddings((prev) => [...prev, wedding]);
						} else {
							setSelectedWeddings((prev) =>
								prev.filter((w) => w.name !== wedding.name)
							);
						}
					}}
					isAllSelected={selectedWeddings.length === weddingsMockData.length}
					onToggleAllWeddings={(checked) => {
						setSelectedWeddings(checked ? [...weddingsMockData] : []);
					}}
				/>
			</Box>
			<div className={styles.schedulerWrap}>
				<div className="calendarWrp commonCalendar ">
					<div className="calendarInner">
						<Scheduler
							disableWeddingDateButton={true}
							onActionBegin={onActionBegin}
							eventSettings={{
								...eventSettings,
								dataSource: filteredEvents,
							}}
							partyMembers={partyMembers}
							allowDragAndDrop={false}
							allowResizing={false}
							height="70dvh"
						/>
					</div>
				</div>
			</div>
		</div>
	)
}
